import {
  faChartSimple,
  faCloudArrowUp,
  faDatabase,
  faHouseCircleExclamation,
  faListCheck,
  faMapLocationDot,
  faShoppingCart
} from '@fortawesome/free-solid-svg-icons';
import {MenuItem} from './shared/models/menu-item.model';

export const APP_MENU: MenuItem[] = [
  {
    label: 'Briefing',
    icon: faListCheck,
    role: 'briefing',
    children: [
      {
        label: 'Anzeigen',
        route: '/briefing/anzeigen',
        role: 'briefing:anzeigen'
      }
    ]
  },
  {
    label: 'Buchen',
    headline: 'Werbung buchen',
    icon: faShoppingCart,
    role: 'buchen',
    children: [
      {
        label: 'Anzeigen',
        route: '/buchen/anzeigen',
        role: 'buchen:anzeigen'
      },
      {
        label: 'Anzeigentool',
        route: '/buchen/anzeigentool',
        role: 'buchen:anzeigen_tool'
      },
      {
        label: 'ATV',
        route: '/buchen/atv',
        role: 'buchen:atv'
      },
      {
        label: 'Digital',
        route: '/buchen/digital_adunit',
        role: 'buchen:digital_adunit',
        children: [
          {
            label: 'Kunden',
            route: '/buchen/digital_adunit/kunden',
            role: 'buchen:digital_adunit:kunden'
          },
          {
            label: 'Werbemittel',
            route: '/buchen/digital_adunit/werbemittel',
            role: 'buchen:digital_adunit:werbemittel'          }
        ]
      },
      {
        label: 'Instore',
        route: '/buchen/instore',
        role: 'buchen:instore'
      },
      {
        label: 'Mailing',
        route: '/buchen/mailing',
        role: 'buchen:mailing'
      },
      {
        label: 'Out of Home',
        route: '/buchen/ooh',
        role: 'buchen:out_of_home'
      },
      {
        label: 'Prospekt',
        route: '/buchen/prospekt',
        role: 'buchen:prospekt'
      },
      {
        label: 'Satellite CRM',
        route: '/buchen/satellite-crm',
        role: 'buchen:satellite_crm'
      },
    ]
  },
  {
    label: 'Dashboards',
    icon: faChartSimple,
    role: 'reports',
    children: [
      {
        label: 'Digital',
        route: '/dashboards/digital_adunit',
        role: 'reports:digital_adunit'
      },
      {
        label: 'Digitales Prospekt',
        route: '/dashboards/digitales_prospekt',
        role: 'reports:digitales_prospekt'
      },
      {
        label: 'Reklamationen',
        route: '/dashboards/reklamationen',
        role: 'reports:reklamationen'
      }
    ]
  },
  {
    label: 'Gebiete',
    headline: 'Werbegebiete',
    icon: faMapLocationDot,
    role: 'gebiete',
    children: [
      {
        label: 'Bearbeiten',
        route: '/gebiete/bearbeiten',
        role: 'gebiete:bearbeiten' // 'stammdaten:filialen'
      },
      {
        label: 'Daten exportieren',
        route: '/gebiete/daten-exportieren',
        role: 'gebiete:dateiexport'
      },
      {
        label: 'MediaMaps',
        route: '/gebiete/mediamaps',
        role: 'gebiete:media_maps'
      }
    ]
  },
  {
    label: 'Stammdaten',
    icon: faDatabase,
    role: 'stammdaten',
    children: [
      {
        label: 'Ansprechpartner',
        route: '/stammdaten/ansprechpartner',
        role: 'stammdaten:ansprechpartner'
      },
      {
        label: 'Filialen',
        route: '/stammdaten/filialen',
        role: 'stammdaten:filialen'
      },
      {
        label: 'Firmen',
        route: '/stammdaten/firmen',
        role: 'stammdaten:firmen'
      },
      {
        label: 'Konditionsverwaltung',
        route: '/stammdaten/konditionsverwaltung',
        role: 'stammdaten:konditionsverwaltung'
      },
      {
        label: 'Medien',
        route: '/stammdaten/medien',
        role: 'stammdaten:medien'
      },
      {
        label: 'Produkte',
        route: '/stammdaten/produkte',
        role: 'stammdaten:produkte'
      },
      {
        label: 'Hilfe & FAQ',
        route: '/stammdaten/faq',
        role: 'stammdaten:faq'
      },
    ]
  },
  {
    label: 'Reklamation',
    icon: faHouseCircleExclamation,
    route: 'reklamation',
    role: 'reklamation',
  },
  {
    label: 'Import',
    icon: faCloudArrowUp,
    role: 'import',
    children: [
      {
        label: 'Adressupdates',
        route: '/import/address-updates',
        role: 'import:adressupdates'
      },
      {
        label: 'Auflagenaktualisierung',
        route: '/import/edition-updates',
        role: 'import:auflagenaktualisierung'
      },
      {
        label: 'Payback-Daten',
        route: '/import/payback-data',
        role: 'import:payback_daten'
      },
      {
        label: 'Verbreitungsdaten',
        route: '/import/distribution-data',
        role: 'import:verbreitungsdaten'
      },
      {
        label: 'Wettbewerberstandorte',
        route: '/import/competitor-locations',
        role: 'import:wettbewerberstandorte'
      }
    ]
  },
];
